//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tidalDropdown from '@tidal/styles-dropdown/src/components/tidal-dropdown.vue';

export default {
    filters: {
        /**
         * @param {Array<{name: string, value: string}>} langOptions
         * @param {Array<string>} availableLangs
         */
        getSupported(langOptions, availableLangs) {
            const newLangOptions = langOptions.filter(function(lang) {
                return availableLangs.indexOf(lang.value) > -1;
            });
            return newLangOptions;
        },
    },
    components: {
        tidalDropdown,
    },
    props: {
        currentLang: {
            type: String,
            required: true,
        },
        availableLangs: {
            type: Array,
            required: true,
        },
        reversed: {
            type: Boolean,
            default: true,
        },
        navigateOnPick: {
            type: Boolean,
            default: true,
        },
        setCookie: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            languageSwitcherOptions: [
                { name: 'English', value: 'en' },
                { name: 'Български', value: 'bg' },
                { name: 'Český ', value: 'cs' },
                { name: 'Deutsch', value: 'de' },
                { name: 'Español', value: 'es' },
                { name: 'Français', value: 'fr' },
                { name: 'Hrvatski', value: 'hr' },
                { name: 'Italiano', value: 'it' },
                { name: '日本語', value: 'ja' },
                { name: 'Norsk', value: 'no' },
                { name: 'Polski', value: 'pl' },
                { name: 'Português', value: 'pt' },
                { name: 'Português (Brasil)', value: 'pt-BR' },
                { name: 'Slovenščina', value: 'sl' },
                { name: 'Srpski', value: 'sr' },
            ],
        };
    },
    computed: {
        /** @returns {{name: string, value: string} | undefined} */
        currentLangObj() {
            return this.languageSwitcherOptions.find(lang => lang.value === this.currentLang);
        },
        ariaLabel() {
            let label = 'Language switcher.';
            if (this.currentLangObj) {
                label += ' ' + this.currentLangObj.name + '.';
            }

            return label;
        },
    },
    methods: {
        /** @param {string} lang */
        setLang(lang) {
            if (this.setCookie) {
                document.cookie = 'app_lang=' + lang + '; domain=tidal.com; path=/; max-age=15780000;' + (location.protocol === 'https' ? ' SameSite=None; Secure' : '');
            }

            if (this.navigateOnPick) {
                const location = window.location.href;
                if (this.setCookie) {
                    return window.location.href = location;
                }

                const langRegexp = /(\?|&)lang=[a-z-]+/i;
                if (location.match(langRegexp)) {
                    window.location.href = location.replace(langRegexp, '$1lang=' + lang);
                } else {
                    const hasQuestionMark = location.indexOf('?') !== -1;
                    window.location.href = `${location}${hasQuestionMark ? '&' : '?'}lang=${lang}`;
                }
            }

            this.$emit('picked', lang);
        },
    },
};
